import { IPriceRule } from 'src/types/price.types';
import { API_URL, PRICE_SCHEME_HEADER } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IPatchPriceRuleRequest, IPriceRuleResponse } from './types';

export const updatePriceRule = async (
  requestBody: IPatchPriceRuleRequest[],
  priceSchemeId: string,
): Promise<IPriceRule[]> => {
  const response = await fetch(`${API_URL}/pricing/price-rules`, {
    method: 'PATCH',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json',
      [PRICE_SCHEME_HEADER]: priceSchemeId,
    },
  });

  if (!response.ok) {
    throw new Error('Something went wrong whilst updating a price rule.');
  }

  const { data }: IPriceRuleResponse = await response.json();
  return data;
};
